module.exports = __webpack_public_path__ + "static/media/help3.bc65023f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/help3.png
// module id = 1438
// module chunks = 8